import { Input, ThemeProvider } from '@alphonsocode/kallos';
import React, { useState, useMemo, useEffect } from 'react';

import useQuery from 'reusable/customHooks/useQuery';
import { SearchStyle } from './style';
import { BsSearch } from 'react-icons/bs';
import { track } from 'analytics/posthog';

function SearchComponent() {
  const [query, setQuery] = useQuery();

  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      track('adsure search submitted', {
        query_length: inputValue.trim().length,
        adsure_test_tag: query.get('testTag') || 'cta',
        my_campaigns: query.get('myCampaigns') === 'true',
        my_tests: query.get('myTests') === 'true',
        surface: 'adsure',
      });
      setQuery({ gSearch: inputValue, page: '1' });
      setInputValue('');
    }
  };
  return (
    <SearchStyle>
      <div className="searchDiv">
        <label className="heading">Search</label>
        {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
        <ThemeProvider defaultMode="light">
          <Input
            placeholder="Search by Names or IDs"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <BsSearch className="searchIcon" />
        </ThemeProvider>
      </div>
    </SearchStyle>
  );
}

export default SearchComponent;
